import React from 'react';
import ThemePicker from './ThemePicker';

const TopBar = ({ round, total, title = 'STAT ATTACK', right }) => {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '8px 14px 6px',
      gap: 8,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 }}>
        <div style={{
          width: 30, height: 30, borderRadius: 8,
          background: 'var(--c-yellow)',
          border: 'var(--border-ink-sm)',
          boxShadow: 'var(--shadow-hard-sm)',
          display: 'grid', placeItems: 'center',
          fontFamily: 'var(--font-display)', fontSize: 13, color: 'var(--c-ink)',
          flexShrink: 0,
        }}>S</div>
        <div style={{ minWidth: 0 }}>
          <div style={{
            fontFamily: 'var(--font-display)', fontSize: 13, lineHeight: 1, letterSpacing: 0.5,
            color: 'var(--c-ink)',
            whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
          }}>{title}</div>
          {round != null && total != null && (
            <div style={{
              fontFamily: 'var(--font-mono)', fontSize: 9, opacity: 0.7, marginTop: 1,
              color: 'var(--c-ink)',
            }}>ROUND {round}/{total}</div>
          )}
        </div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {right}
        <ThemePicker />
      </div>
    </div>
  );
};

export default TopBar;
